"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  className: "hoi-poi-select__search",
  name: "magnifier"
});

var _default = /*#__PURE__*/_react.default.memo(function (_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return _reactSelect.components.ValueContainer && /*#__PURE__*/_react.default.createElement(_reactSelect.components.ValueContainer, props, _ref2, children);
});

exports.default = _default;